import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'models';

const initialState: AppState = {
  loading: false,
  isLogIn: false,
  portals: [],
  userSettings: null,
  privacyPolicy: null,
  repairInstruction: null,
  repairInstructionEng: null,
  warningMessage: null,
  loggingOut: false,
  logoURL: null,
};

type A<T extends keyof AppState> = PayloadAction<AppState[T]>;

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoginState(state, action: A<'isLogIn'>) {
      state.isLogIn = action.payload;
    },
    setLoadingState(state, action: A<'loading'>) {
      state.loading = action.payload;
    },
    setPortals(state, action: A<'portals'>) {
      state.portals = action.payload;
    },
    setUserSettings(state, action: A<'userSettings'>) {
      state.userSettings = action.payload;
    },
    setPrivacyPolicy(state, action: A<'privacyPolicy'>) {
      state.privacyPolicy = action.payload;
    },
    setRepairInstruction(state, action: A<'repairInstruction'>) {
      state.repairInstruction = action.payload;
    },
    setWarningMessage(state, action: A<'warningMessage'>) {
      state.warningMessage = action.payload;
    },
    setLoggingOutStatus(state, action: A<'loggingOut'>) {
      state.loggingOut = action.payload;
    },
    logout(state, action: PayloadAction<string | null | undefined>) {
      return {
        ...state,
        loggingOut: false,
        isLogIn: false,
        warningMessage: action.payload ?? null,
      };
    },
    setInsturctions(
      state,
      action: PayloadAction<{
        portals: AppState['portals'];
        userSettings: AppState['userSettings'];
        privacyPolicy: AppState['privacyPolicy'];
        repairInstruction: AppState['privacyPolicy'];
        repairInstructionEng: AppState['repairInstructionEng'];
        logoURL: AppState['logoURL'];
      }>
    ) {
      return {
        ...state,
        isLogIn: true,
        logoURL: action.payload.logoURL,
        portals: action.payload.portals,
        userSettings: action.payload.userSettings,
        privacyPolicy: action.payload.privacyPolicy,
        repairInstruction: action.payload.repairInstruction,
        repairInstructionEng: action.payload.repairInstructionEng,
      };
    },
  },
});

export const { reducer, actions } = appSlice;
